<div class="d-flex justify-content-between">
    <label>{{ "widget_product_detail_label" | translate }}</label>
    <a (click)="addSection()">{{ "widget_product_add_section" | translate }}</a>
</div>
@for (section of sections.controls; track section; let i = $index) {
    <div class="row p-relative">
        <div class="form-group mb-10 pr-40 col-xs-12">
            <input
                class="form-control"
                placeholder="{{ 'widget_product_section_name' | translate }}"
                [formControl]="section.controls.name"
            />
        </div>
        <button
            class="btn-link remove-btn"
            [class.disabled]="sections.controls.length === 1"
            (click)="removeSection(i)"
        >
            <span class="sp-icon icon-bin"></span>
        </button>
    </div>
    @for (param of sections.at(i).controls.parameters.controls; track param; let index = $index) {
        <div class="row p-relative">
            <div class="form-group col-xs-6 mb-10 pr-5">
                <input
                    type="text"
                    class="form-control"
                    placeholder="{{ 'widget_product_parameter_placeholder' | translate }}"
                    [formControl]="param.controls.parameter"
                />
            </div>
            <div class="form-group col-xs-6 mb-10 pl-5 pr-40">
                <input
                    type="text"
                    class="form-control"
                    placeholder="{{ 'widget_product_value_placeholder' | translate }}"
                    [formControl]="param.controls.value"
                />
            </div>
            <button
                class="btn-link remove-btn"
                [class.disabled]="sections.at(i).controls.parameters.controls.length === 1"
                (click)="removeParameter(i, index)"
            >
                <span class="sp-icon icon-bin"></span>
            </button>
        </div>
    }
    <div class="form-group mb-20">
        <a (click)="addParameter(i)">{{ "widget_product_add_parameter" | translate }}</a>
    </div>
}
<div class="row mb-20">
    <div class="form-group col-xs-4">
        <label class="radio-inline">
            <input type="radio" [checked]="isPhysicalType" (change)="changeType(ProductType.physical)" />
            {{ "widget_product_physical_label" | translate }}
        </label>
    </div>
    <div class="form-group col-xs-4">
        <label class="radio-inline">
            <input type="radio" [checked]="isDigitalType" (change)="changeType(ProductType.digital)" />
            {{ "widget_product_digital_label" | translate }}
        </label>
    </div>
</div>
@if (isDigitalType) {
    <div class="row mb-20">
        <div class="form-group col-xs-12" [class.has-error]="digitalProductLink.invalid && digitalProductLink.touched">
            <label>{{ "widget_product_digital_link" | translate }}</label>
            <input
                type="text"
                class="form-control"
                placeholder="{{ 'widget_product_digital_link_placeholder' | translate }}"
                [formControl]="digitalProductLink"
            />
            @if (digitalProductLink.invalid && digitalProductLink.touched) {
                <span class="help-block small">
                    {{ "control_errors_required" | translate }}
                </span>
            }
        </div>
    </div>
}
<div class="row">
    <div class="form-group col-xs-4 mb-20 pr-10">
        <label>{{ "widget_product_vendor_code" | translate }}</label>
        <input type="text" class="form-control" placeholder="A456B445" [formControl]="controls.vendorCode" />
    </div>
    @if (isPhysicalType) {
        <div class="form-group col-xs-5 mb-20 pl-10">
            <label>{{ "widget_product_quantity" | translate }}</label>
            <div class="row">
                <div class="col-xs-8 pr-5">
                    <input
                        placeholder="&#8734;"
                        type="number"
                        class="form-control"
                        [min]="0"
                        [formControl]="controls.quantity"
                        (blur)="validateInputValue($event.target['value'])"
                    />
                </div>
                <!--            <div class="col-xs-4 pl-5">-->
                <!--                <select class="form-control" [formControl]="controls.unit">-->
                <!--                    <option *ngFor="let option of options" [ngValue]="option" [selected]="option === controls.unit.value">{{ 'widget_product_quantity_' + option | translate }}</option>-->
                <!--                </select>-->
                <!--            </div>-->
            </div>
        </div>
    }
</div>
